import React, { useMemo } from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { CHART_COLORS } from '../../utils/constants';

export default function JobStatusChart({ data }) {
  const chartData = useMemo(() => {
    const counts = {};
    data.forEach(job => {
      const s = job.status || 'Unknown';
      counts[s] = (counts[s] || 0) + 1;
    });
    const total = data.length;
    // Drop slices that round to 0% - a real but negligible count just clutters the chart
    return Object.entries(counts)
      .map(([name, value]) => ({ name, value }))
      .filter(({ value }) => total > 0 && Math.round((value / total) * 100) > 0);
  }, [data]);

  if (!chartData.length) return <div style={{ textAlign:'center', color:'#94a3b8', padding:'3rem' }}>No job data</div>;

  return (
    <ResponsiveContainer width="100%" height={260}>
      <PieChart>
        <Pie data={chartData} cx="50%" cy="50%" outerRadius={90} dataKey="value" label={({ name, percent }) => `${name} ${(percent*100).toFixed(0)}%`} labelLine={false}>
          {chartData.map((_, i) => <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />)}
        </Pie>
        <Tooltip />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
}
